import { executeRequest, JFSRequest } from '@jfs/network'
import { RootStore } from '../data/store'
import { isSuccessResponse } from './../utils/index'
import { APIEndPoints } from './APIEndPoints'
import { getHeaders, getUrl, sitConfig } from './config'
import { isLocalHostUrl } from './fetchGroupByRiskAudit'

const responseParser = (response: any) => {
  const data = isSuccessResponse(response)
  return data?.data
}

const processTransactionApi = (req: any) => {
  const request: JFSRequest<{}> = {
    apiPath: isLocalHostUrl
      ? 'http://localhost:8080/api/v1.0/risk/process'
      : getUrl(APIEndPoints.processTransactionApi),
    method: 'POST',
    cache: false,
    config: sitConfig(RootStore.session.getTokens),
    headers: {
      ...getHeaders(),
      ...(isLocalHostUrl && { appIDToken: '66', 'x-channel-id': '66' }),

    },
    body: req,
  }

  return executeRequest(request)
    .then(responseParser)
    .catch((error) => {
      throw error
    })
}

export { processTransactionApi }
